import { JsonObject } from '../../helpers';
import { ConnectorFeatureSet, ConnectorUser } from './';
import { ConnectorModel } from './connector.model';

export type ProxyIpRangeConfig = {
  cidr: string;
  status: 'pending' | 'active';
};

export type ProxyConfig = {
  authenticationType: 'user' | 'user-connector-fallback' | 'connector';
  orgAuthEnabled: boolean;
  pacFileUrl: string;
  serviceUrl?: string;
  catalogUrl?: string;
  user: ConnectorUser | undefined;
  userId: string;
  emailProxyIdEnabled?: boolean;
  sourceCIDRs?: ProxyIpRangeConfig[];
};

export class ProxyConnectorModel extends ConnectorModel {
  config: ProxyConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'proxy';
    this.typeLabel = 'Proxy';
    this.icon = 'proxy';

    this.supportedFeatures = (data.supportedFeatures as ConnectorFeatureSet) || {
      siem: false,
      privateModels: false,
      contextData: false,
      ingress: true,
    };

    this.config = (data.config as ProxyConfig) || {
      authenticationType: 'user-connector-fallback',
      orgAuthEnabled: false,
      pacFileUrl: '',
      user: undefined,
      userId: '',
      emailProxyIdEnabled: false,
      sourceCIDRs: [],
    };
  }
  get hasConnectorAuthentication(): boolean {
    return ['user-connector-fallback', 'connector'].includes(this.config.authenticationType);
  }
}
